<template>
  <nav class="navbar fixed-top">
    <div class="d-flex align-items-center navbar-left">
      <a
        href="#"
        class="menu-button d-none d-md-block"
        @click.prevent.stop="
          changeSideMenuStatus({
            step: menuClickCount + 1,
            classNames: menuType,
            selectedMenuHasSubItems
          })
        "
      >
        <menu-icon />
      </a>
      <a
        href="#"
        class="menu-button-mobile d-xs-block d-sm-block d-md-none"
        @click.prevent.stop="changeSideMenuForMobile(menuType)"
      >
        <mobile-menu-icon />
      </a>
    </div>
    <router-link class="navbar-logo" to="/">
      <span class="logo">金旺宏形象網站管理後台</span>
      <!-- <span class="logo-mobile d-block d-xs-none">金旺宏&nbsp;&nbsp;形象網站管理後台</span> -->
    </router-link>

    <div class="navbar-right">
      <!-- <div class="header-icons d-inline-block align-middle">
        <div class="position-relative d-inline-block">
          <b-dropdown
            variant="empty"
            size="sm"
            right
            toggle-class="header-icon notificationButton"
            menu-class="position-absolute mt-3 notificationDropdown"
            no-caret
          >
            <template slot="button-content">
              <i class="simple-icon-bell" />
              <span class="count">3</span>
            </template>
            <vue-perfect-scrollbar
              :settings="{ suppressScrollX: true, wheelPropagation: false }">
              <div
                class="d-flex flex-row mb-3 pb-3 border-bottom"
                v-for="(n, index) in notifications"
                :key="index"
              >
                <router-link tag="a" to="/app/pages/product/details">
                  <img
                    :src="n.img"
                    :alt="n.title"
                    class="img-thumbnail list-thumbnail xsmall border-0 rounded-circle"
                  />
                </router-link>
                <div class="pl-3 pr-2">
                  <router-link tag="a" to="/app/pages/product/details">
                    <p class="font-weight-medium mb-1">{{ n.title }}</p>
                    <p class="text-muted mb-0 text-small">{{ n.date }}</p>
                  </router-link>
                </div>
              </div>
            </vue-perfect-scrollbar>
          </b-dropdown>
        </div>
      </div> -->
      <div class="user d-inline-block" v-if="currentUser">
        <b-dropdown
          class="dropdown-menu-right"
          right
          variant="empty"
          toggle-class="p-0"
          menu-class="mt-3"
          no-caret
        >
          <template slot="button-content">
            <span class="name mr-1">{{ currentUser.name }}</span>
            <span>
              <img :alt="currentUser.name" src="../../assets/img/header/member.svg" />
            </span>
          </template>
          <b-dropdown-item
            :to="{ name: 'admin-edit', params: { adminId: currentUser.id} }"
          >我的帳號</b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="logout">Sign out</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { MenuIcon, MobileMenuIcon } from '@/components/piaf/Svg/index';

import {
  menuHiddenBreakpoint,
} from '@/configs/app';

export default {
  components: {
    'menu-icon': MenuIcon,
    'mobile-menu-icon': MobileMenuIcon,
  },
  data() {
    return {
      menuHiddenBreakpoint,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      menuType: 'menu/getMenuType',
      menuClickCount: 'menu/getMenuClickCount',
      selectedMenuHasSubItems: 'menu/getSelectedMenuHasSubItems',
    }),
  },
  methods: {
    ...mapMutations({
      changeSideMenuStatus: 'menu/changeSideMenuStatus',
      changeSideMenuForMobile: 'menu/changeSideMenuForMobile',
    }),

    logout() {
      this.$router.push({
        name: 'auth-logout',
      });
    },
  },
};
</script>
